import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';
import { Platform } from '@angular/cdk/platform';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

// Create the injection token for the custom settings
export const RNFIPAY_CONFIG = new InjectionToken('RelipayCustomConfig');

@Injectable({
  providedIn: 'root',
})
export class RnfiConfigService {
  private _configSubject: BehaviorSubject<any> = new BehaviorSubject(null);
  private readonly _defaultConfig: any;

  constructor(
    private _platform: Platform,
    private _router: Router,
    @Inject(RNFIPAY_CONFIG) private _config: any
  ) {
    this._defaultConfig = _config;
    this._init();
  }

  set config(value) {
    let config = this._configSubject.getValue();
    config = this.deepMerge({}, config, value);
    this._configSubject.next(config);
  }

  get config(): any | Observable<any> {
    return this._configSubject.asObservable();
  }

  get defaultConfig(): any {
    return this._defaultConfig;
  }

  private _init(): void {
    if (this._platform.ANDROID || this._platform.IOS) {
      this._defaultConfig.customScrollbars = false;
    }

    this._configSubject.next(this.deepClone(this._defaultConfig));

    this._router.events
      .pipe(filter((event) => event instanceof ResolveEnd))
      .subscribe(() => {
        if (!this.isEqual(this._configSubject.getValue().layout, this._defaultConfig.layout)) {
          const config = this.deepClone(this._configSubject.getValue());
          config.layout = this.deepClone(this._defaultConfig.layout);
          this._configSubject.next(config);
        }
      });
  }

  setConfig(value: any, opts = { emitEvent: true }): void {
    let config = this._configSubject.getValue();
    config = this.deepMerge({}, config, value);
    if (opts.emitEvent === true) {
      this._configSubject.next(config);
    }
  }

  getConfig(): Observable<any> {
    return this._configSubject.asObservable();
  }

  resetToDefaults(): void {
    this._configSubject.next(this.deepClone(this._defaultConfig));
  }

  // Utility functions
  private deepClone(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  private deepMerge(target: any, ...sources: any[]): any {
    for (const source of sources) {
      for (const key in source) {
        if (source[key] && typeof source[key] === 'object') {
          target[key] = this.deepMerge(target[key] || {}, source[key]);
        } else {
          target[key] = source[key];
        }
      }
    }
    return target;
  }

  private isEqual(a: any, b: any): boolean {
    return JSON.stringify(a) === JSON.stringify(b);
  }

}


// import { Inject, Injectable, InjectionToken } from '@angular/core';
// import { ResolveEnd, Router } from '@angular/router';
// import { Platform } from '@angular/cdk/platform';
// import { BehaviorSubject, Observable } from 'rxjs';
// import { filter } from 'rxjs/operators';
// import * as _ from 'lodash';
// // Create the injection token for the custom settings
// export const RNFIPAY_CONFIG = new InjectionToken('RelipayCustomConfig');
// @Injectable({
//   providedIn: 'root',
// })
// export class RnfiConfigService {
//   // Private functions
//   private _configSubject: BehaviorSubject<any> = new BehaviorSubject(null);
//   private readonly _defaultConfig: any;
//   constructor(
//     private _platform: Platform,
//     private _router: Router,
//     @Inject(RNFIPAY_CONFIG) private _config: any
//   ) {
//     // Set the default config from the user provided config (from forRoot)
//     this._defaultConfig = _config;

//     // Initialize the service
//     this._init();
//   }

//   // -----------------------------------------------------------------------------------------------------
//   // @ Accessors
//   // -----------------------------------------------------------------------------------------------------

//   /**
//    * Set and get the config
//    */
//   set config(value) {

//     // Get the value from the behavior subject
//     let config = this._configSubject.getValue();

//     // Merge the new config
//     config = _.merge({}, config, value);

//     // Notify the observers
//     this._configSubject.next(config);
//   }

//   get config(): any | Observable<any> {
//     return this._configSubject.asObservable();
//   }

//   /**
//    * Get default config
//    *
//    * @returns {any}
//    */
//   get defaultConfig(): any {
//     return this._defaultConfig;
//   }

//   // -----------------------------------------------------------------------------------------------------
//   // @ Private methods
//   // -----------------------------------------------------------------------------------------------------

//   /**
//    * Initialize
//    *
//    * @private
//    */
//   private _init(): void {
//     /**
//      * Disable custom scrollbars if browser is mobile
//      */
//     if (this._platform.ANDROID || this._platform.IOS) {
//       this._defaultConfig.customScrollbars = false;
//     }

//     // Set the config from the default config
//     this._configSubject.next(_.cloneDeep(this._defaultConfig));

//     // Reload the default layout config on every RoutesRecognized event
//     // if the current layout config is different from the default one

//     this._router.events
//       .pipe(filter((event) => event instanceof ResolveEnd))
//       .subscribe((e) => {

//         if (
//           !_.isEqual(
//             this._configSubject.getValue().layout,
//             this._defaultConfig.layout
//           )
//         ) {
//           // Clone the current config
//           const config = _.cloneDeep(this._configSubject.getValue());

//           // Reset the layout from the default config
//           config.layout = _.cloneDeep(this._defaultConfig.layout);

//           // Set the config
//           this._configSubject.next(config);
//         }
//       });
//   }

//   // -----------------------------------------------------------------------------------------------------
//   // @ Public methods
//   // -----------------------------------------------------------------------------------------------------

//   /**
//    * Set config
//    *
//    * @param value
//    * @param {{emitEvent: boolean}} opts
//    */
//   setConfig(value: any, opts = { emitEvent: true }): void {
//     // Get the value from the behavior subject
//     let config = this._configSubject.getValue();

//     // Merge the new config
//     config = _.merge({}, config, value);

//     // If emitEvent option is true...
//     if (opts.emitEvent === true) {
//       // Notify the observers
//       this._configSubject.next(config);
//     }
//   }

//   /**
//    * Get config
//    *
//    * @returns {Observable<any>}
//    */
//   getConfig(): Observable<any> {
//     return this._configSubject.asObservable();
//   }

//   /**
//    * Reset to the default config
//    */
//   resetToDefaults(): void {
//     // Set the config from the default config
//     this._configSubject.next(_.cloneDeep(this._defaultConfig));
//   }
// }
